<p-toast></p-toast>
<div class="h-full center-container">
  <div class="grid">
    <div class="card">
      <p-toolbar>
        <div class="p-toolbar-group-center">
          <h3 class="m-0">Update Tenant Info</h3>
        </div>
      </p-toolbar>
      <div class="col-12">

          <div *ngIf="!loadingTenantDetails; else spinner">
            <div *ngIf="tenantDetails; else noTenantFound">
              <form [formGroup]="tenantForm" autocomplete="off">
                <div class="grid p-fluid mt-5">
                  <div class="field col-6 sm:col-3">
                        <label for="suite">Suite</label>
                        <input pInputText type="number" id="suite" formControlName="suite"/>
                </div>

                <div class="field col-6 sm:col-3">
                    <label for="account">Account Number</label>
                    <input pInputText  type="number" id="account" formControlName="account"/>
                </div>

                <div class="field col-6 sm:col-3">
                    <label for="account">Non-Tax Code</label>
                    <input pInputText  type="text" id="tax_code" formControlName="tax_code"/>
                </div>

                <p-fieldset legend="Bill To Address" class="field col-12">
                  <div class="grid">
                    <div class="field col-6 md:col-3">
                      <label for="name" class="label-required w-full">Tenant Name</label>
                        <input pInputText type="text" id="name" formControlName="name" />
                      <div *ngIf="formSubmitted && tenantForm.controls['name'].errors">
                        <div class="ui-messages-error" *ngIf="tenantForm.controls['name'].errors?.['required']">Please
                          enter tenant name.
                        </div>
                      </div>
                    </div>

                    <!-- <div class="field col-6 md:col-3" *ngIf="tenantDetails?.wpsActive && tenantDetails?.parkingDevice == 'surepark'">
                      <span class="flex align-items-center gap-1" pTooltip="Create group with default SUREPARK settings">
                        <p-checkbox formControlName="new_company" [binary]="true" inputId="new_company"></p-checkbox>
                        <label for="new_company">Create New SUREPARK Company</label>
                      </span>
                    </div> -->

                    <div class="field col-6 md:col-3" *ngIf="tenantDetails?.wpsActive && tenantDetails?.parkingDevice == 'surepark'">
                        <label for="wps_company">Company Name (Group Name)</label>
                        <p-dropdown formControlName="wps_company" [options]="sureparkGroupList" optionLabel="name"
                          optionValue="id" placeholder="Select Company Name" class="w-full"
                          id="wps_company" appendTo="body" [filter]="true" filterBy="name"
                          aria-describedby="wps_company-help" [showClear]="true">
                          <ng-template let-item pTemplate="item">
                            <div class="flex align-items-center justify-content-between">
                              <span>{{ item.name }}</span>
                              <span *ngIf="item.id === ''" class="text-green-500 text-sm ml-2">(New)</span>
                              <span *ngIf="item.isAssigned" class="text-red-500 text-sm ml-2">(Assigned to {{ item.assignedTo }})</span>
                            </div>
                          </ng-template>
                          <ng-template let-item pTemplate="selectedItem">
                            <div class="flex align-items-center justify-content-between">
                              <span>{{ item.name }}</span>
                              <span *ngIf="item.id === ''" class="text-green-500 text-sm ml-2">(New)</span>      
                            </div>
                          </ng-template>
                        </p-dropdown>
                    </div>
                    
                    <div class="field col-6 md:col-3 flex-column" *ngIf="tenantDetails?.wpsActive && tenantDetails?.parkingDevice == 'surepark'">
                      <label for="create_company">&nbsp;</label>
                      <p-button [disabled]="tenantUpdating" [severity]="tenantForm.value['new_company'] ? 'success' : 'primary'" label="{{ tenantForm.value['new_company'] ? 'Edit New Group Details' : 'Create Group' }}" (click)="displayNewGroupDialog()"></p-button>
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="email">Billing Email Address</label>
                        <input pInputText type="text" id="email" formControlName="email" />
                        <div *ngIf="formSubmitted && tenantForm.controls['email'].errors">
                          <div class="ui-messages-error" *ngIf="tenantForm.controls['email'].errors?.['invalidEmails']">
                                  One or more email addresses are invalid.
                          </div>
                        </div>
                    </div>

                    <!-- <div class="field col-6 md:col-3">
                      <label for="billto">Bill To</label>
                        <input pInputText type="text" id="billto" formControlName="billto" />
                    </div> -->

                    <div class="field col-6 md:col-3">
                        <label for="address1" class="label-required w-full">Street Address Line 1</label>
                        <input pInputText type="text" id="address1" formControlName="address1" />
                        <div *ngIf="formSubmitted && tenantForm.controls['address1'].errors">
                          <div class="ui-messages-error" *ngIf="tenantForm.controls['address1'].errors?.['required']">Please
                            enter bill to address.
                          </div>
                        </div>
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="address2">Street Address Line 2</label>
                        <input pInputText type="text" id="address2" formControlName="address2" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="city" class="label-required w-full">City</label>
                        <input pInputText type="text" id="city" formControlName="city" />
                        <div *ngIf="formSubmitted && tenantForm.controls['city'].errors">
                          <div class="ui-messages-error" *ngIf="tenantForm.controls['city'].errors?.['required']">Please
                            enter city.
                          </div>
                        </div>
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="state" class="w-full">State</label>
                        <p-dropdown formControlName="state" [options]="states" optionLabel="name"
                          optionValue="code" placeholder="Select a State" class="w-full"
                          id="state" appendTo="body" [filter]="true" filterBy="name" [showClear]="true"/>
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="suite" class="label-required w-full">Zip Code</label>
                        <input pInputText type="text" id="zip" formControlName="zip" />
                        <div *ngIf="formSubmitted && tenantForm.controls['zip'].errors">
                          <div class="ui-messages-error" *ngIf="tenantForm.controls['zip'].errors?.['required']">Please
                            enter zip.
                          </div>
                          <div class="ui-messages-error" *ngIf="!tenantForm.controls['zip'].errors?.['required'] && tenantForm.controls['zip'].errors?.['pattern']">Please
                            enter valid zip.
                          </div>
                        </div>
                    </div>
                  </div>
                </p-fieldset>

                <p-fieldset legend="Account Preferences" class="col-12" styleClass="field col-12">
                  <div class="grid">
                    <div class="field col-12">
                      <label for="invoice_delivery" class="label-required w-full">Invoice Delivery</label>
                          <p-dropdown formControlName="invoice_delivery" [options]="invoiceBatchOptions" optionLabel="name"
                            optionValue="code" placeholder="Select Invoice Delivery" styleClass="w-full" id="invoice_delivery" appendTo="body"/>
                    </div>
                  </div>
                </p-fieldset>

                <div class="field col-12" *ngIf="!loadingTenantContacts">
                  <app-contacts-list source="attendant-portal" [suite]="queryParams.suite" [account]="queryParams.account" style="width: 100%;"></app-contacts-list>
                </div>

                <!-- <div class="field col-12">
                  <app-invoice-contact-list module="tenant" [location]="currentLocation" [suite]="queryParams.suite" [account]="queryParams.account"
                                            style="width: 100%;"></app-invoice-contact-list>
                </div> -->

                <div class="col-12">
                  <div class="grid">
                    <div class="col-12 flex align-content-center justify-content-end">
                      <p-button [loading]="tenantUpdating" class="col-offset-6 mt-2" label="Save Changes" (click)="saveTenantData()"></p-button>
                    </div>
                  </div>
                </div>
              </div>
              </form>
              <p-dialog [(visible)]="showNewGroupDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
                header="Create SUREPARK Group" [style]="{width: '50vw'}" [dismissableMask]="true">
              
                <app-new-surepark-group-form [lotIdOptions]="lotIdOptions" [timezoneGroupOptions]="timezoneGroupOptions"></app-new-surepark-group-form>
                
                <ng-template pTemplate="footer">
                  <p-button label="Cancel" severity="danger" (click)="closeNewGroupDialog()">
                  </p-button>
                  <p-button label="Clear" severity="warning" (click)="clearNewGroupDetails()">
                  </p-button>
                  <p-button label="Save Group" (click)="saveNewGroupDetails()">
                  </p-button>
                </ng-template>
              </p-dialog>
            </div>
        </div>
      </div>
    </div>
    <ng-template #spinner>
      <p-progressSpinner></p-progressSpinner>
    </ng-template>
    <ng-template #noTenantFound>
        <h1>Unable to load tenant details.</h1>
    </ng-template>
  </div>
</div>
